import { render } from "./PageOutro.vue?vue&type=template&id=590c76d0&scoped=true"
import script from "./PageOutro.vue?vue&type=script&lang=js"
export * from "./PageOutro.vue?vue&type=script&lang=js"

import "./PageOutro.vue?vue&type=style&index=0&id=590c76d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590c76d0"]])

export default __exports__